import React from "react";
import { useNavigate } from "react-router-dom";

function DashBoardCard({ icon, title, number, progress, link }) {
  const navigate = useNavigate();
  const handleClick = (link) => {
    navigate(link);
  };

  return (
    <div
      className=" max-w-full cursor-pointer bg-white border border-[#CBD5E1] rounded-lg  p-5  px-2 transition duration-300 ease-in-out hover:shadow-lg "
      onClick={() => handleClick(link)}
    >
      <div className=" h-full   flex flex-col items-center justify-between ">
        <img
          src={icon}
          alt="icons"
          className="p-1 w-[60%] aspect-[3/2] object-contain rounded-md  mb-2"
        />
        <h2 className=" text-sm font-bold text-[#151C28] text-center ">
          {title}
        </h2>
        <p className="text-[10px] text-[#151C28] mb-1">{progress}</p>
        <p className="text-xs text-[#151C28]">{number}</p>
      </div>
    </div>
  );
}

export default DashBoardCard;
